module.exports = "img/e2e/warning.a0cb4f2.svg";